module.exports = __webpack_public_path__ + "static/omisakin-1e8974b621558fb583d6291595f232e5.png";